import { Reveal } from "../landing/shared";

const STEPS = [
  { n: "01", name: "CLARIFY", desc: "Confirm your goals, timeline, the entitlement and documentation questions in front of you, and the decision that's actually blocking movement." },
  { n: "02", name: "STRUCTURE", desc: "Look at the full transaction together: the financing path, an existing property or obligations, cash-to-close inputs, and the options worth evaluating." },
  { n: "03", name: "GUIDE", desc: "Get a plain-language next-step plan and coordination through the application and the process that follows." },
];

export default function MethodStrip() {
  return (
    <section id="method" className="border-y border-white/10" data-testid="method-section">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-[#404653]/40">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1}>
            <div className="relative p-8 lg:p-12 overflow-hidden h-full" data-testid={`method-step-${s.n}`}>
              <span
                className="absolute -top-5 -right-2 font-mono-strict font-bold text-white/[0.04] select-none pointer-events-none"
                style={{ fontSize: "10rem", lineHeight: 1 }}
              >
                {s.n}
              </span>
              <p className="font-mono-strict text-[10px] tracking-[0.3em] text-[#0162CA] mb-4">THE BETTER DEAL METHOD™</p>
              <h3 className="font-black uppercase text-2xl tracking-tight mb-3">{s.name}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <div className="max-w-7xl mx-auto px-8 lg:px-12 py-5 border-t border-white/10">
        <p className="text-[11px] text-white/35">
          Educational framework. It does not determine eligibility, approval, rate, payment, costs, or timing —
          those depend on your complete file, the property, program guidelines, and underwriting.
        </p>
      </div>
    </section>
  );
}
